import { render } from "./ListOfDirectors.vue?vue&type=template&id=03f95536&scoped=true"
import script from "./ListOfDirectors.vue?vue&type=script&lang=js"
export * from "./ListOfDirectors.vue?vue&type=script&lang=js"

import "./ListOfDirectors.vue?vue&type=style&index=0&id=03f95536&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f95536"]])

export default __exports__